import React from 'react';
import { Skeleton, Box } from '@mui/material';

function FolderLoader() {
  return (
    <>
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Skeleton variant="text" width={140} />
      </Box>
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            mb: 3,
          }}
        >
          <Skeleton variant="rectangular" height={150} />
        </Box>
      ))}
    </>
  );
}

export default FolderLoader;
